import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    TOKEN: "JWT_TOKEN",
    instance_id: "bb-cc-dd",
    fbKey: 0,
    showWidget: true,
    checkBoxRendered: false,
    globalVars: {
      locale: "",
      payment_currency: "",
      is_free: "",
      pricing_plan: "",
      billing_cycle: "",
      created_at: "",
      last_install: "",
    },
    widgetVars: {
      id: 0,
      instance_id: "",
      website_id: 0,
      facebook_widget_type: "",
      header_background_color: "",
      popup_background_color: "",
      pop_up_title: "",
      pop_up_title_font_family: "",
      pop_up_title_font_color: "",
      pop_up_title_font_type: "",
      pop_up_title_font_size: 0,
      pop_up_message: "",
      pop_up_message_font_family: "",
      pop_up_message_font_color: "",
      pop_up_message_font_type: "",
      pop_up_message_font_size: 0,
      pop_up_cancel: "",
      pop_up_cancel_font_family: "",
      pop_up_cancel_font_color: "",
      pop_up_cancel_font_type: "",
      pop_up_cancel_font_size: 0,
      button_text: "",
      button_background: "",
      button_font_family: "",
      button_font_color: "",
      button_font_type: "",
      button_font_size: 0,
      button_corners: "",
      button_border_size: 0,
      button_border_color: "",
      active: false,
      wdgt_key_internal: 0,
      changesSaved: true,
      all_steps_completed: true,
      enabled_widgets: {
        sms: 99999,
        facebook: 99999,
        whatsapp:99999
      },
      discount_statement: "",
      apply_discount_instruction: "",
      discount_code: "",
      subscribe_type: "",
    },
    settingsVar: {
      messenger_app_id: "",
      page_id: "",
      div_class: "",
    },
    checkBoxUserRef: "",
    checkBoxState: "",
    showErrFlashFB: false,
  },
  getters: {
    checkClicked: (state) => (id) => {
      return state.navState.currentSelected === id ? true : false;
    },
    getCheckBoxUserRef: (state) => {
      return state.checkBoxUserRef;
    },
    getCheckBoxState: (state) => {
      return state.checkBoxState;
    },
    getLocale: (state) => {
      return state.globalVars.locale;
    },
    getCreatedAt: (state) => {
      return state.globalVars.created_at;
    },
    getWidgetsState: (state) => {
      return state.widgetVars;
    },
    getDisplayWidget: (state) => {
      return state.showWidget && state.widgetVars.all_steps_completed;
    },
    getFbDetails: (state) => {
      return state.settingsVar;
    },
    getFbKey: (state) => {
      return state.fbKey;
    },
    getInstanceId: (state) => {
      return state.instance_id;
    },
    getCheckBoxRendered: (state) => {
      return state.checkBoxRendered;
    },
    getErrFlashFB: (state) => {
      return state.showErrFlashFB;
    },
  },
  mutations: {
    SET_SELECTED(state, id) {
      state.navState.currentSelected = id;
    },
    SET_CARTS_VAL(state, obj) {
      state.cartsState.carts = obj.carts;
    },
    SET_TOKEN(state, token) {
      state.TOKEN = token;
    },

    SET_WIDGETS_VAL(state, obj) {
      state.widgetVars.id = obj.id;
      state.widgetVars.instance_id = obj.instance_id;
      state.widgetVars.website_id = obj.website_id;
      state.widgetVars.facebook_widget_type = obj.facebook_widget_type;
      state.widgetVars.header_background_color = obj.header_background_color;
      state.widgetVars.popup_background_color = obj.popup_background_color;
      state.widgetVars.pop_up_title = obj.pop_up_title;
      state.widgetVars.pop_up_title_font_family = obj.pop_up_title_font_family;
      state.widgetVars.pop_up_title_font_color = obj.pop_up_title_font_color;
      state.widgetVars.pop_up_title_font_type = obj.pop_up_title_font_type;
      state.widgetVars.pop_up_title_font_size = obj.pop_up_title_font_size;
      state.widgetVars.pop_up_message = obj.pop_up_message;
      state.widgetVars.pop_up_message_font_family =
        obj.pop_up_message_font_family;
      state.widgetVars.pop_up_message_font_color =
        obj.pop_up_message_font_color;
      state.widgetVars.pop_up_message_font_type = obj.pop_up_message_font_type;
      state.widgetVars.pop_up_message_font_size = obj.pop_up_message_font_size;
      state.widgetVars.pop_up_cancel = obj.pop_up_cancel;
      state.widgetVars.pop_up_cancel_font_family =
        obj.pop_up_cancel_font_family;
      state.widgetVars.pop_up_cancel_font_color = obj.pop_up_cancel_font_color;
      state.widgetVars.pop_up_cancel_font_type = obj.pop_up_cancel_font_type;
      state.widgetVars.pop_up_cancel_font_size = obj.pop_up_cancel_font_size;
      state.widgetVars.button_text = obj.button_text;
      state.widgetVars.button_background = obj.button_background;
      state.widgetVars.button_font_family = obj.button_font_family;
      state.widgetVars.button_font_color = obj.button_font_color;
      state.widgetVars.button_font_type = obj.button_font_type;
      state.widgetVars.button_font_size = obj.button_font_size;
      state.widgetVars.button_corners = obj.button_corners;
      state.widgetVars.button_border_size = obj.button_border_size;
      state.widgetVars.button_border_color = obj.button_border_color;
      state.widgetVars.active = obj.active;
      state.widgetVars.changesSaved = true;
      state.widgetVars.all_steps_completed = obj.all_steps_completed;
      if (obj.enabled_widgets.facebook != undefined) {
        state.widgetVars.enabled_widgets.facebook =
          obj.enabled_widgets.facebook;
      } else {
        state.widgetVars.enabled_widgets.facebook = false;
      }

      if(obj.enabled_widgets.whatsapp != undefined){
        state.widgetVars.enabled_widgets.whatsapp = obj.enabled_widgets.whatsapp
      } else {
        state.widgetVars.enabled_widgets.whatsapp = false;
      }

      if (obj.enabled_widgets.sms != undefined) {
        state.widgetVars.enabled_widgets.sms = obj.enabled_widgets.sms;
      } else {
        state.widgetVars.enabled_widgets.sms = false;
      }

      state.widgetVars.discount_statement = obj.discount_statement;
      state.widgetVars.apply_discount_instruction =
        obj.apply_discount_instruction;
      state.widgetVars.discount_code = obj.discount_code;
      state.widgetVars.subscribe_type = obj.subscribe_type;
    },
    SET_FB_SETTINGS(state, obj) {
      state.settingsVar.messenger_app_id = obj.messenger_app_id;
      state.settingsVar.page_id = obj.page_id;
      state.settingsVar.div_class = "fb-send-to-messenger";
    },
    TOGGLE_DISPLAY(state) {
      state.showWidget = false;
    },
    INCR_FB_KEY(state) {
      state.fbKey++;
    },
    SET_INSTANCE(state, id) {
      state.instance_id = id;
    },
    SET_CHCKBX_RNDRD(state, val) {
      state.checkBoxRendered = val;
    },
    SET_ERR_FB_FLASH(state, val) {
      state.showErrFlashFB = val;
    },
  },
  actions: {
    updateToken({ commit }, token) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", token);
        resolve("success");
      });
    },
    updateClick({ commit }, id) {
      commit("SET_SELECTED", id);
    },
    updateTimezone({ commit }, timezone_id) {
      return new Promise((resolve) => {
        commit("SET_TIMEZONE", timezone_id);
        resolve("success");
      });
    },
    updAccInfo({ commit }, obj) {
      return new Promise((resolve) => {
        commit("SET_ACC_INFO", obj);
        resolve("success");
      });
    },
    getGlobal({ commit }) {
      return new Promise((resolve, reject) => {
        let url = `${process.env.VUE_APP_API_URL_DEV}/websites/${this.state.instance_id}`;
        let headers = {
          headers: {
            authorization: this.state.TOKEN,
          },
        };

        axios
          .get(url, headers)
          .then((res) => {
            commit("SET_GLOBAL_VALS", JSON.parse(JSON.stringify(res.data)));
            resolve("success");
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getWidgets({ commit }, instance_id) {
      return new Promise((resolve, reject) => {
        if (instance_id != undefined) {
          let url = `${process.env.VUE_APP_API_URL_DEV}/widgetsnippet?instance_id=${instance_id}`;
          axios
            .get(url)
            .then((res) => {
              commit("SET_WIDGETS_VAL", JSON.parse(JSON.stringify(res.data)));
              // console.log(JSON.stringify(res.data));
              resolve("success");
            })
            .catch((error) => {
              reject(error);
            });
        }
        else{
          resolve("success");
        }
      });
    },
    getSettings({ commit }, instance_id) {
      return new Promise((resolve, reject) => {
        let url = `${process.env.VUE_APP_API_URL_DEV}/getfbpageappdetails?instance_id=${instance_id}`;
        axios
          .get(url)
          .then((res) => {
            commit("SET_FB_SETTINGS", JSON.parse(JSON.stringify(res.data)));
            resolve("success");
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    sendSMSOptin({ commit }, obj) {
      return new Promise((resolve, reject) => {
        let url = `${process.env.VUE_APP_API_URL_DEV}/smsOptinWebhook`;
        let headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        // console.log(obj.cart_id == undefined)
        if(obj.cart_id == undefined){
          obj.cart_id = null
        }
        // console.log(obj.cart_id)
        let data = obj;
        // console.log("Sending sms optin" + JSON.stringify(data));
        axios
          .post(url, data, headers)
          .then(() => {
            // console.log(res);
            resolve("success");
          })
          .catch((error) => {
            reject(error);
            console.log(commit);
          });
      });
    },
    sendWaOptin({ commit }, obj) {
      return new Promise((resolve, reject) => {
        let url = `${process.env.VUE_APP_API_URL_DEV}/whatsappOptinWebhook`;
        let headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        // console.log(obj.cart_id == undefined)
        if(obj.cart_id == undefined){
          obj.cart_id = null
        }
        // console.log(obj.cart_id)
        let data = obj;
        // console.log("Sending sms optin" + JSON.stringify(data));
        axios
          .post(url, data, headers)
          .then(() => {
            // console.log(res);
            resolve("success");
          })
          .catch((error) => {
            reject(error);
            console.log(commit);
          });
      });
    },

    updFbSettings({ commit }, obj) {
      return new Promise((resolve) => {
        commit("SET_FB_SETTINGS", obj);
        resolve("success");
      });
    },
    toggleDisplay({ commit }) {
      return new Promise((resolve) => {
        commit("TOGGLE_DISPLAY");
        resolve("success");
      });
    },
    incrementFBKey({ commit }) {
      return new Promise((resolve) => {
        commit("INCR_FB_KEY");
        resolve("success");
      });
    },
    setInstanceId({ commit }, id) {
      return new Promise((resolve) => {
        commit("SET_INSTANCE", id);
        resolve("success");
      });
    },
    setCheckboxRendered({ commit }, val) {
      return new Promise((resolve) => {
        commit("SET_CHCKBX_RNDRD", val);
        resolve("success");
      });
    },
    setErrFlashFB({ commit }, val) {
      return new Promise((resolve) => {
        commit("SET_ERR_FB_FLASH", val);
        resolve("success");
      });
    },
  },
  modules: {},
});

export default store;
